import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { IUser } from '../../models/user'

import { emptyUser, initialState } from './configs'

const accessManagementSlice = createSlice({
  name: 'accessManagement',
  initialState,
  reducers: {
    selectUser: (state, action: PayloadAction<IUser>) => {
      state.selectedUser = action.payload
      state.isNewUser = false
    },
    resetSelectedUser: (state) => {
      state.selectedUser = emptyUser
      state.isNewUser = true
    },
  },
})

export const { selectUser, resetSelectedUser } = accessManagementSlice.actions

export const accessManagementReducer = accessManagementSlice.reducer
